import React from 'react';
import CustomModal from '../../components/CustomModal';
import useModalState from '../../context/modal/useModalState';
import Spinner from '../../components/Spinner';

const WaitingModal: React.FC = () => {
    const { modalData } = useModalState();

    return (
        <CustomModal
            modalName='waitingModal'
            className='status-modal waiting-modal'
            overlayClassName='status-modal'
            shouldCloseOnOverlayClick={false}
        >
            <div className='content'>
                <Spinner />
                <div
                    className='status'
                    dangerouslySetInnerHTML={{ __html: modalData?.status }}
                />
            </div>
        </CustomModal>
    );
};

export default WaitingModal;
